import React from "react"
/* eslint-disable */
interface DownloadProps {
  onClick?: () => {} | void
  className?: string
  width?: string
  height?: string
  stroke?: string
  strokeWidth?: string
}
function DownloadIcon(prop: DownloadProps) {
  const { onClick, className, width, height, stroke, strokeWidth } = prop
  const cssClassName = className || ""
  const cssWidth = width || "1em"
  const cssHeight = height || "1em"
  const cssStroke = stroke || "currentColor"
  const cssStrokeWidth = strokeWidth || "0.5"
  return (
    <span onClick={onClick} className="anticon anticon-add">
      <svg
        className={cssClassName}
        xmlns="http://www.w3.org/2000/svg"
        width={cssWidth}
        height={cssHeight}
        fill="none"
        viewBox="0 0 22 22"
      >
        <path
          d="M19.8104 16.4869C19.8104 16.1639 20.0722 15.9015 20.3958 15.9015C20.7187 15.9015 20.9811 16.1639 20.9811 16.4869C20.9811 17.7287 20.4734 18.8573 19.6556 19.6745C18.8378 20.4923 17.7098 21 16.4681 21H5.51309C4.27134 21 3.14275 20.4923 2.32553 19.6745C1.50773 18.8567 1 17.7287 1 16.4869C1 16.1639 1.2624 15.9015 1.5854 15.9015C1.90896 15.9015 2.17079 16.1639 2.17079 16.4869C2.17079 17.4057 2.54698 18.2407 3.15313 18.8468C3.75927 19.453 4.59488 19.8292 5.51306 19.8292H16.468C17.3868 19.8292 18.2218 19.453 18.8279 18.8468C19.4341 18.2407 19.8103 17.4051 19.8103 16.4869H19.8104ZM10.4057 13.8646V1.5854C10.4057 1.2624 10.6681 1 10.9911 1C11.3141 1 11.5765 1.2624 11.5765 1.5854V13.8646L17.1246 8.31646C17.3535 8.08762 17.7241 8.08762 17.9522 8.31646C18.1811 8.5453 18.1811 8.91594 17.9522 9.14405L11.4047 15.6916C11.1758 15.9205 10.8052 15.9205 10.5765 15.6916L4.02892 9.14405C3.80008 8.91521 3.80008 8.54457 4.02892 8.31646C4.25777 8.08762 4.62841 8.08762 4.85652 8.31646L10.4046 13.8646H10.4057Z"
          fill="currentColor"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
        />
      </svg>
    </span>
  )
}

export default DownloadIcon
